export default {
  ACTIVE: 1,
  VALUATION: 2,
  CLOSED: 3,
  CANCELED: 4,
}
